import { createValidationSchema, stringField, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const deleteTenantPaymentCredentials = {
    name: "deleteTenantPaymentCredentials",
    description: "Deactivates payment credentials for a tenant (idempotent).",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        tenantId: uuidField({
            required: true,
            message: "Debe ingresar un ID de tenant válido",
        }),
        provider: stringField({
            required: true,
            message: "El provider es requerido",
        }),
    }),
    useCase: async ({ db, tenantConnectionResolver, }, { tenantId, provider }) => {
        const tenant = await db.findOne(TenantEntity, {
            where: { id: tenantId },
        });
        if (!tenant)
            return new TenantNotFoundError();
        const connection = await tenantConnectionResolver.open(tenant.dbName);
        try {
            await connection.manager.query(`UPDATE payment_credentials SET isActive = false WHERE provider = ? AND isActive = true`, [provider]);
            return {
                success: true,
            };
        }
        finally {
            await connection.release();
        }
    },
};
